export const INPUT_TYPES = [
  'Alfanumérico',
  'Numérico',
  'Lista desplegable',
  'Fecha',
  'Check',
  'Carga de documentos',
  'Radio Buton'
];

export const PROVIDERS = [
  'Proveedor',
  'Host to host',
  'Mayorista',
  'Comercio',
  'Cajero'
];

export const TYPE_FILES = [
  'PDF',
  'Word'
];
